import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { useInView } from "react-intersection-observer";

import Julia from "../images/skins/Julia.png";
import Steve from "../images/skins/Steve.png";

export default function ScaleServer() {
  const ref = useRef(null);
  const [juliaRef, juliaInView] = useInView({ threshold: 0.3 });
  const [steveRef, steveInView] = useInView({ threshold: 0.3 });
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });

  //scaling
  const juliaScale = useTransform(scrollYProgress, [0, 1], [1, 3]);
  const steveScale = useTransform(scrollYProgress, [0, 1], [1, 0.3]);

  //offset to keep them on the floor
  const juliaYOffset = useTransform(scrollYProgress, [0, 1], [0, 50]); 
  const steveYOffset = useTransform(scrollYProgress, [0, 1], [0, 0]); 

  return (
    <section
      ref={ref}
      className="relative min-h-screen bg-gradient-to-b from-indigo-900 to-purple-900 flex flex-col md:flex-row items-center justify-center px-8 py-20 overflow-hidden"
    >
      <div className="flex flex-col items-center justify-center w-full md:w-1/2 space-y-8">
        <motion.div
          className="relative flex gap-12 items-end"
          style={{ perspective: "1000px" }}
        >
          {/*the floor*/}
          <div className="absolute bottom-0 left-0 right-0 h-1 bg-white/10 rounded-full" />

          <motion.img
            ref={juliaRef}
            animate={juliaInView ? "visible" : "hidden"}
            src={Julia}
            alt="Julia"
            style={{
              scale: juliaScale,
              y: juliaYOffset,
              transformOrigin: "bottom center",
            }}
            className="w-24 origin-bottom"
          />
          <motion.img
            ref={steveRef}
            animate={steveInView ? "visible" : "hidden"}
            src={Steve}
            alt="Steve"
            style={{
              scale: steveScale,
              y: steveYOffset,
              transformOrigin: "bottom center",
            }}
            className="w-24 origin-bottom"
          />
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0, x: 100 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        className="w-full md:w-1/2 text-center md:text-left mt-12 md:mt-0"
      >
        <h3 className="text-4xl text-pinky font-bold mb-4">Scale Server</h3>
        <p className="text-gray-200 text-lg max-w-md">
          Julia’s world where scale decides fate.
          Giants roam the server, while the smallest players build beneath.
        </p>
      </motion.div>
    </section>
  );
}